import { render, staticRenderFns } from "./BSidebar.vue?vue&type=template&id=7e88c4c6&scoped=true&"
import script from "./BSidebar.vue?vue&type=script&lang=ts&"
export * from "./BSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./BSidebar.vue?vue&type=style&index=0&id=7e88c4c6&prod&lang=scss&scoped=true&"
import style1 from "./BSidebar.vue?vue&type=style&index=1&id=7e88c4c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e88c4c6",
  null
  
)

export default component.exports